module.exports = __webpack_public_path__ + "static/Air_Conditioners-5fe1ad6e4065a74d352a36de1d4b06cd.png";